module.exports = __webpack_public_path__ + "media/trail_of_burning_doom.4afe1228.webm";